import { Button } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { UserMentionedNotificationParams } from 'apis/notifications';
import { useAppNavigate } from 'utils/url/useAppNavigate';

import { HistoricalNotification } from '../../notificationsPage.types';
import { NotificationRow } from '../notificationRow/notificationRow';

type UserMentionedNotificationProps = {
  notification: HistoricalNotification;
  userMentionedData: UserMentionedNotificationParams;
};

export const UserMentionedNotification = ({
  notification,
  userMentionedData: { mentioned_on },
}: UserMentionedNotificationProps): JSX.Element => {
  const navigate = useAppNavigate();

  return (
    <NotificationRow
      notification={notification}
      action={
        <Button
          variant="secondary"
          onClick={() => {
            navigate({
              path: '/conversation/:csid',
              params: { path: { csid: `${mentioned_on.conversation_id}` } },
            });

            ampli.mentionUserNotificationClicked();
          }}
        >
          Go to conversation
        </Button>
      }
    />
  );
};
